import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import BrandHeader from '../BrandHeader.jsx';
import Footer from '../Footer.jsx';
import '../../styles/hub.css';

const TABS = [
  { to: '', label: 'Home', end: true },
  { to: '/domains', label: 'Exam Domains' },
  { to: '/study-plan', label: 'Study Plan' },
  { to: '/flashcards', label: 'Flashcards' },
  { to: '/practice-test', label: 'Practice Test' },
  { to: '/objective-tests', label: 'Objective Tests' },
  { to: '/resources', label: 'Resources' },
  { to: '/cheat-sheet', label: 'Cheat Sheet' },
];

export default function HubLayout({ config, children }) {
  const base = `/hub/${config.slug}`;
  const links = TABS.map((t) => ({ to: base + t.to, label: t.label, end: !!t.end }));

  return (
    <>
      <BrandHeader links={links} homeTo={base} />

      <div className="hub-titlebar">
        <div className="hub-titlebar-inner">
          <span className="eyebrow">{config.vendorTag}</span>
          <h1>{config.title}<span className="accent">{config.titleAccent}</span> Study Hub</h1>
          <span className="hub-code">{config.code}</span>
          <Link to="/ai-settings" className="ai-settings-link">AI Settings</Link>
          <Link to="/" className="hub-titlebar-back"><ArrowLeft aria-hidden="true" /> Command Center</Link>
        </div>
      </div>

      <main id="main">{children}</main>

      <Footer />
    </>
  );
}